import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { connect } from 'react-redux'
import { get } from 'lodash'
import { Export } from 'containers/misc'
import { Row, Col, Button } from 'components/misc'
import { Table, Header, Data } from 'components/layout/Table'
import { variables } from 'constants/layout'
import { modal } from 'redux/modules/app'
import { apiActivities } from 'helpers/decorators/api'

@apiActivities(null, {
  modal
})
class VariablesActivities extends Component {
  static propTypes = {
    activities: PropTypes.object.isRequired
  }

  render() {
    const { activities } = this.props

    return (
      <div>
        <Row alignItems="center" alignContent="stretch" gutters>
          <Col flex="1 1 auto">
            <h1 className="beta reset--margin">Activities</h1>
          </Col>
          <Col right>
            <Button disabled>New Activity</Button>
          </Col>
          <Col flex="0 1 auto">
            <Export />
          </Col>
        </Row>

        <Table loading={activities.loading}>
          <Header ths={variables.tableHeaders} />
          <Data>
            {activities.list.map(item => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{get(item, 'activitySection.translationText')}</td>
                <td>---</td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default VariablesActivities
